var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SrSelect',{attrs:{"value":_vm.value,"items":_vm.availableVastVersions,"label":"Vast Version","required":""},on:{"change":_vm.onValueChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }